import { render, staticRenderFns } from "./DxEmployees.vue?vue&type=template&id=63de08a1&scoped=true&"
import script from "./DxEmployees.vue?vue&type=script&lang=js&"
export * from "./DxEmployees.vue?vue&type=script&lang=js&"
import style0 from "./DxEmployees.vue?vue&type=style&index=0&id=63de08a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63de08a1",
  null
  
)

export default component.exports